// Module
var code = "<section> <div class=\"placeholder-image\"></div> <div class=\"info-container\"> <p class=\"text-capitalize lighten\">{{ ::$ctrl.text.title }}</p> <cr-icon-label-value data=\"$ctrl.attribute\" value-key=\"enumValues\"></cr-icon-label-value> <p class=\"text-capitalize lighten\">{{ ::$ctrl.text.description }}</p> </div> </section> ";
// Exports
export default code;